import './Skills.css';

const skillGroups = [
  {
    label: 'Languages',
    icon: '{ }',
    skills: ['HTML5', 'CSS3', 'JavaScript', 'TypeScript', 'PHP'],
  },
  {
    label: 'Frameworks & Libraries',
    icon: '⚛',
    skills: ['React JS', 'Tailwind CSS', 'Mantine UI', 'Chakra UI', 'Material UI'],
  },
  {
    label: 'Tools & Platforms',
    icon: '🛠',
    skills: ['Git', 'GitHub', 'PgAdmin', 'VS Code', 'Figma'],
  },
  {
    label: 'Database',
    icon: '🗄',
    skills: ['PostgreSQL'],
  },
  {
    label: 'Soft Skills',
    icon: '🤝',
    skills: ['Collaboration', 'Communication', 'Problem-solving', 'Attention to Detail'],
  },
];

const techIcons = {
  'HTML5': '#E34F26',
  'CSS3': '#1572B6',
  'JavaScript': '#F7DF1E',
  'TypeScript': '#3178C6',
  'PHP': '#777BB4',
  'React JS': '#61DAFB',
  'Tailwind CSS': '#06B6D4',
  'Mantine UI': '#339AF0',
  'Chakra UI': '#319795',
  'Material UI': '#007FFF',
  'Git': '#F05032',
  'GitHub': '#fff',
  'PgAdmin': '#336791',
  'PostgreSQL': '#336791',
  'VS Code': '#007ACC',
  'Figma': '#F24E1E',
};

export default function Skills() {
  return (
    <section className="skills section" id="skills">
      <div className="container">
        <div className="section-label">
          <span className="label-line" />
          <span>Skills</span>
        </div>
        <h2 className="section-title">What I work with</h2>

        <div className="skills-grid">
          {skillGroups.map((group) => (
            <div className="skill-group" key={group.label}>
              <div className="group-header">
                <span className="group-icon">{group.icon}</span>
                <span className="group-label">{group.label}</span>
              </div>
              <div className="skill-tags">
                {group.skills.map((skill) => (
                  <div
                    className="skill-tag"
                    key={skill}
                    style={{ '--dot-color': techIcons[skill] || 'var(--accent)' }}
                  >
                    <span className="skill-dot" />
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="skills-marquee">
          <div className="marquee-track">
            {[...skillGroups.flatMap(g => g.skills), ...skillGroups.flatMap(g => g.skills)].map((s, i) => (
              <span key={i} className="marquee-item">{s}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
